// extracted by mini-css-extract-plugin
export default {"verifyContainer":"Verification_verifyContainer__9o9Jv","title":"Verification_title__skvt4","message":"Verification_message__TW5QF","checkIcon":"Verification_checkIcon__25ELw"};